// Subscription API surface (spec #75).
import { fetchJson } from './http';
import type { SubscriptionView } from './types';

export const subscriptionApi = {
  async getCurrent(getToken: () => string | null) {
    return await fetchJson<SubscriptionView>('/subscription', getToken);
  },

  async restore(getToken: () => string | null) {
    return await fetchJson<SubscriptionView>('/subscription/restore', getToken, {
      method: 'POST',
      body: {},
    });
  },
};
